import DefaultLayout from "@/layouts/DefaultLayout";
import ThirdPartyServiceForm from "kinnect-front/ThirdPartyServices/ThirdPartyServiceForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog } from "kinnect-general";
import { ThirdPartyService } from "kinnect-models";

export default {
	name: "ThirdPartyServicePage",

	metaInfo() {
		let title = "3rd Party Services";

		if ( this.editing && this.fetched ) {
			title = `${title} - ${this.thirdPartyService.name}`;
		} else if ( this.editing ) {
			title = `${title} - Loading...`;
		} else {
			title = `${title} - Add a 3rd Party Service`;
		}

		return { title };
	},

	props: { idThirdPartyService: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "third_party_services",
		deleteDialogOpen: false,
		thirdPartyService: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idThirdPartyService );
		},

		genDeleteDialog() {
			if ( this.editing && this.thirdPartyService && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete third party service" )}
					onConfirm={() => this.thirdPartyService.delete()}
					redirect={[ "back", { name: "thirdPartyServices" } ]}
					title="Delete 3rd party Service"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the 3rd party service <strong>{this.thirdPartyService.name}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Service",
					tooltip: "Delete this 3rd party service"
				};
			}
		}
	},

	methods: {
		async fetchThirdPartyService() {
			if ( this.editing ) {
				this.thirdPartyService = await ThirdPartyService.findPageModel(
					this.idThirdPartyService
				);
			}
		},

		async fetch() {
			await this.fetchThirdPartyService();
		}
	},

	render() {
		return <DefaultLayout maxWidth="600px">
			<ThirdPartyServiceForm
				loading={this.$wait.is( "find third party service" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
				thirdPartyService={this.thirdPartyService}
			></ThirdPartyServiceForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
